<template>
  <div :class="{
    [$style.overlay]: true,
    [$style.transparent]: transparent}">
    <img src="../../assets/img/progress-circle-success.svg" :class="$style.loader" />
    <p v-if="message" :class="$style.message">{{ message }}</p>
  </div>
</template>

<script>
  export default {
    props: ['transparent', 'message']
  }
</script>

<style module lang="less" src="./loading-overlay.less"></style>



// WEBPACK FOOTER //
// loading-overlay.vue?236527cd